import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    uid: undefined,
    email: undefined,
    name: undefined,
    account: undefined,
    role: undefined,
  },
  reducers: {
    removeUser: (state) => {
      state.uid = undefined;
      state.email = undefined;
      state.name = undefined;
      state.account = undefined;
      state.role = undefined;
    },
    setUser: (state, action) => {
      const { uid, email, name, account, role } = action.payload;
      state.uid = uid;
      state.email = email;
      state.name = name;
      state.account = account;
      state.role = role;
    },
  },
});

export const { removeUser, setUser } = userSlice.actions;

export default userSlice.reducer;
